import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ kanbanBoardId }) => {
  return await dponetAPI.get(`/kanban_boards/${kanbanBoardId}/kanban_columns`)
}

const create = async ({ kanbanBoardId, ...data }) => {
  return await dponetAPI.post(
    `/kanban_boards/${kanbanBoardId}/kanban_columns`,
    { kanbanColumn: data },
  )
}

const update = async ({ kanbanBoardId, kanbanColumnId, ...data }) => {
  return await dponetAPI.put(
    `/kanban_boards/${kanbanBoardId}/kanban_columns/${kanbanColumnId}`,
    { kanbanColumn: data },
  )
}

const destroy = async ({ kanbanBoardId, kanbanColumnId }) => {
  return await dponetAPI.delete(
    `/kanban_boards/${kanbanBoardId}/kanban_columns/${kanbanColumnId}`,
  )
}

const reorder = async ({ kanbanBoardId, ids }) => {
  return await dponetAPI.patch(
    `/kanban_boards/${kanbanBoardId}/kanban_columns/reorder`,
    { ids },
  )
}

export default {
  create,
  destroy,
  get,
  reorder,
  update,
}
